export default __webpack_public_path__ + "static/media/105t.d83572d3.jpg";